import React from 'react';
import { useCategoryPriceDistributionFetch } from './hooks';
import PriceDistributionView from '../PriceDistributionView/PriceDistributionView';
import { PriceVarianceFilter } from 'src/types/PriceVarianceFilter';
import useSourceOwnerId from 'src/hooks/useSourceOwnerId';
import useQueryUrlParams from 'src/hooks/useQueryUrlParams';

export const CATEGORY_ITEMS_PER_PAGE = 15;

export type CategoryPriceAnalysisProps = {
  priceVariance: PriceVarianceFilter[] | null;
  loading: boolean;
};

const CategoryPriceAnalysis: React.FC<CategoryPriceAnalysisProps> = ({
  priceVariance,
  loading,
}: CategoryPriceAnalysisProps) => {
  const sourceOwnerId = useSourceOwnerId();
  const { matchTypeFilter = 'ALL', region = '-1', priceType = '2' } = useQueryUrlParams();
  const [fetchState] = useCategoryPriceDistributionFetch(sourceOwnerId, matchTypeFilter, region, priceType);
  return (
    <PriceDistributionView
      {...fetchState}
      loading={fetchState.loading || loading}
      priceVariance={priceVariance}
      itemsPerPage={CATEGORY_ITEMS_PER_PAGE}
      queryParameter={'category'}
    />
  );
};

export default CategoryPriceAnalysis;
